<template lang="pug">

    .two.fields

        //- Adresse
        dropdown-field(
            label=''
            optionLabel='name'
            optionValue='id'
            v-bind:options='addressModelOptions'
            v-model='address'
        )

        //- Menge
        number-field(label='' v-model='amount')

</template>

<script>
    import * as R from 'ramda'
    import * as AddressUtils from '@/utils/address'
    import DropdownField from '@/components/form/DropdownField.vue'
    import NumberField from '@/components/form/NumberField.vue'

    export default {

        components: { DropdownField, NumberField },

        computed: {

            address: {
                get() { return this.value.address },
                set(value) { this.updateValue('address', value) }
            },

            addressModelOptions() {
                return R.compose(

                    // Name der Standardadresse formatieren
                    R.map(AddressUtils.format_name_by_default_shipping_address),

                    // Nach Standardadresse sortieren
                    AddressUtils.sort_by_is_default_shipping_address

                )(this.addressModels)
            },

            amount: {
                get() { return this.value.amount },
                set(value) { this.updateValue('amount', value) }
            },

        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            }

        },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }

        }

    }

</script>
